import { Zap, BarChart3, Target, Share2 } from 'lucide-react';

export function AboutFutWorkSection() {
  const features = [
    { 
      icon: Zap, 
      text: "Real-time skill tracking at your fingertips" 
    },
    { 
      icon: BarChart3, 
      text: "Comprehensive session and progress analytics" 
    },
    { 
      icon: Target, 
      text: "Personalized training strategies for every level" 
    },
    { 
      icon: Share2, 
      text: "Effortless sharing with coaches and parents" 
    }
  ];

  return (
    <section className="py-10 md:py-12 bg-background">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Title */}
        <h2 className="text-3xl md:text-5xl font-bold italic text-foreground text-center mb-8 md:mb-10">
          ABOUT FUTWORK.IO
        </h2>

        <div className="grid lg:grid-cols-2 gap-1 md:gap-2 items-center">
          {/* Left Column - Features */}
          <div className="space-y-3 order-2 lg:order-1">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div 
                  key={feature.text}
                  className="flex gap-3 items-center animate-fade-in"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <Icon className="h-6 w-6 md:h-7 md:w-7 text-primary flex-shrink-0" />
                  <p className="text-base md:text-lg text-foreground">
                    {feature.text}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Right Column - App Mockup */}
          <div className="relative flex justify-center lg:justify-start lg:-ml-8 order-1 lg:order-2">
            <div className="relative w-full max-w-[240px] md:max-w-[280px]">
              {/* Video with white border and shadow */}
              <div className="relative aspect-[9/19.5] border-4 border-white rounded-[2.5rem] overflow-hidden shadow-2xl">
                <video
                  className="w-full h-full object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src="https://futwork-videos.s3.us-east-1.amazonaws.com/desktop/About_Video+2.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
